/* ============================================================
   NORTHSHEEP — buy-box description: "Read more" only when needed

   The description sits in the buy box as short product-specific text. A
   description longer than the clamp (set in CSS, ~7 lines) is faded out at
   the clamp and gets a "Read more" that opens it in place. A short one gets
   nothing — no button, no fade — which is the point of measuring rather than
   always clamping.

   Re-measured on resize and after a variant change, because Dawn re-renders
   the product info on a variant switch and the width changes the line count.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsBuyboxDesc) return;
  window.__nsBuyboxDesc = true;

  /* The spec-row ("table") look for bold-label list items is pure CSS — see
     northsheep-product.css. A stricter JS test lived here briefly; the owner
     preferred the original look, so it was removed. */

  function measure() {
    var boxes = document.querySelectorAll('[data-ns-desc]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.classList.contains('is-open')) continue;
      var body = box.querySelector('[data-ns-desc-body]');
      var more = box.querySelector('[data-ns-desc-more]');
      if (!body || !more) continue;
      // Measure unclamped, then decide. A small allowance so a description
      // that is only a word or two over does not get a button for one line.
      box.classList.remove('is-clamped');
      var clampPx = parseFloat(getComputedStyle(box).getPropertyValue('--ns-desc-clamp')) || 190;
      var needs = body.scrollHeight > clampPx + 24;
      box.classList.toggle('is-clamped', needs);
      more.hidden = !needs;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-ns-desc-more]');
    if (!btn) return;
    var box = btn.closest('[data-ns-desc]');
    if (!box) return;
    box.classList.add('is-open');
    box.classList.remove('is-clamped');
    btn.setAttribute('aria-expanded', 'true');
    btn.hidden = true;
  });

  var t = null;
  function later() { clearTimeout(t); t = setTimeout(measure, 120); }

  function start() {
    measure();
    window.addEventListener('resize', later, { passive: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, later);
    }
    // Web fonts change line lengths; measure again once they are in.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    /* A colour swap (ns-colour-siblings.js) puts a new description in place
       and this file, run again, stops at the guard above: the server renders
       it unclamped with the button hidden, so a long one showed in full with
       no "Read more" (audit, 23 Sep 2026). Measure the new one. */
    document.addEventListener('ns:colour-swapped', later);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
